// #6606: the user edit page renders a holder first from the cached cap table, then fetches the fresh record. These
// tell whether the fresh record's shares or documents differ from what was rendered, so the page rebuilds the view.

/** JSON with object keys sorted, so the same data serializes the same whatever order its keys came back in. */
export function stableJson(value) {
	if (Array.isArray(value)) return `[${value.map(stableJson).join(',')}]`;
	if (value && typeof value === 'object') {
		return `{${Object.keys(value)
			.sort()
			.map((k) => `${JSON.stringify(k)}:${stableJson(value[k])}`)
			.join(',')}}`;
	}
	return JSON.stringify(value ?? null);
}

/** A fingerprint of what the edit page shows for a holder in one client: shares (classes, balances, grants) and
 * documents (DR03). View counts are left out, as in the server's snapshot hash, so opening a document doesn't count. */
export function holderViewFingerprint(holder, client) {
	const node = holder?.clients?.[client];
	if (!node) return 'null';
	const documents = Array.isArray(node.documents) ? node.documents.map((d) => (d && typeof d === 'object' ? { ...d, views: undefined } : d)) : null;
	return stableJson({ shares: node.shares ?? null, documents });
}
